import { useQuery } from "react-query";
import { mapAttributeDataByTaskKey } from "../../../components/attributes/lib/attribute-data";
import { formatAttributeGroups } from "../../format-attributes";

import { CODING_TASK_ROLES } from "components/coding/lib/constants";

export const useAttributesByRole = (taskKey, taskType, codingWipKey, references, isBrandVerified, group) => {
    return useQuery({
        queryKey: ["roleAttributes", taskKey, taskType],
        queryFn: () =>
            mapAttributeDataByTaskKey(codingWipKey, taskKey, references, isBrandVerified, group).then((data) => {
                return formatAttributeGroups(data);
            }),
        enabled: CODING_TASK_ROLES.includes(taskType),
    });
};
